export default "__VITE_ASSET__D$AzBQcp__"